import {h, Fragment} from "preact"
/* Nosto Face */
import { useFacet } from "@nosto/preact";
import { useState, useEffect } from "preact/hooks";
import Checkbox from "./elements/Checkbox";
import Icon from "./elements/Icon";
import Facets from "./elements/facetsData";

export default function Facet({ facetIn }) {
    const [facet, setFacet] = useState();
    const [activeSelect, setActiveSelect] = useState(true);
    const [showAll, setShowAll] = useState(false);
    const { toggleProductFilter } = useFacet(facetIn);
    const initialVisibleCount = 10;

    useEffect(() => {
        const sortWashFilters = (filters, name) => {
            if (!filters?.length || filters.length < 2) return null;

            const facetsDataFilter = Facets.find(data => data.name === name);
            if (!facetsDataFilter) return null;

            return filters.sort((a, b) => {
                const iA = facetsDataFilter.values.indexOf(a.value);
                const iB = facetsDataFilter.values.indexOf(b.value);
                return iA === -1 ? 1 : iB === -1 ? -1 : iA - iB;
            });
        };

        if (facetIn?.data && facetIn.name) {
            const sortedData = sortWashFilters(facetIn.data, facetIn.name);
            if (sortedData) {
                setFacet({ ...facetIn, data: sortedData });
            } else {
                setFacet(facetIn);
            }
        }
    }, [facetIn]);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 768px)");
    
        const handleMediaChange = (e) => {
            setActiveSelect(e.matches);
        };
    
        handleMediaChange(mediaQuery);
    
        mediaQuery.addEventListener("change", handleMediaChange);
    
        return () => {
            mediaQuery.removeEventListener("change", handleMediaChange);
        };
    }, []);

    if (!facet) return null;

    //const visibleItems = showAll ? facet.data : facet.data?.slice(0, initialVisibleCount);
    const visibleItems = showAll 
    ? facet.data.filter(value => value.count > 0)
    : facet.data.filter(value => value.count > 0).slice(0, initialVisibleCount);


    return (
        <li class={`ns-sidebar-dropdown pd-sidebar-dropdown ${activeSelect ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-pt-4 ns-pb-2"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={() => setActiveSelect(!activeSelect)}
            >
                <span class="ns-color-black ns-font-5 pd-text-uppercase">{facet.name}</span>
                <Icon name="arrow" className="ns-absolute" />
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-py-4">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {visibleItems?.map((value) => (
                        <li
                            class="ns-d-flex ns-align-items-center ns-font-3"
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={(e) => {
                                    e.preventDefault();
                                    toggleProductFilter(facet.field, value.value, !value.selected);
                                }}
                            />
                            <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-color-black ns-border-radius-3">
                                ({value.count})
                            </span>
                        </li>
                    ))}
                </ul>
                {/* Botón Show More / Show Less */}
                {facet.data?.length > initialVisibleCount && (
                    <button
                        class="pd-button ns-d-block ns-mt-4 ns-font-5"
                        onClick={() => setShowAll(!showAll)}
                    >
                        <Icon name={showAll ? "minus" : "plus"} />
                        {showAll ? "Show Less" : "Show More"}
                    </button>
                )}
            </div>
        </li>
    );
}
